export const mouse = { 
    x: -100, 
    y: -100,
    fix: {
        enabled: false,
        x: -100,
        y: -100
    }
}
